var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapChart"},[_c('h2',{staticClass:"title-item"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"midtop",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }